import React from 'react'
import DrawerTitle from 'src/Components/Drawer/DrawerTitle';
import AddressForm from 'src/Components/Forms/AddressForm';
import { AllTabType, IAddressData } from 'src/types/GlobalInterfaces';

interface IProps {
  setActiveTab?: (tab: AllTabType) => void;
  onBack?: () => void;
  setPickAddress?: (address: any) => void;
  pickAddress?: any;
  setIsEditAddress?: (isEditAddress: boolean) => void;
  isEditAddress?: boolean;
  onSuccess?: () => void;
}

const AddressFormSection = ({ setActiveTab, onBack, setPickAddress, pickAddress, setIsEditAddress, isEditAddress, onSuccess }: IProps) => {
  return (
    <>
      <DrawerTitle title="Address Form" onBack={onBack} backBtn />
      <div className="w-full">
        <AddressForm
          data={pickAddress}
          onConfirm={(data: IAddressData) => {
            console.log("Addresses ===> ", data);
            setIsEditAddress?.(false);
            setPickAddress?.(null);
            setActiveTab?.("ManageAddress");
            onSuccess?.();
          }}
          isEdit={isEditAddress}
          className="!max-h-fit !min-h-[calc(100vh-150px)] !h-fit side-bar-padding-3 flex flex-col gap-2"
          btnContainerClass="!sticky bottom-0 left-0 bg-drawer px-2 2xl:px-3 py-[2px] 2xl:py-1 shadow-all"
          hasCustomPadding
          onEditSuccess={() => {
            setIsEditAddress?.(false);
            setPickAddress?.(null);
            setActiveTab?.("ManageAddress");
          }}
        />
      </div>
    </>
  )
}

export default AddressFormSection